'use client';

import { c as _c } from "react/compiler-runtime";
import type { HistoryChangeGroup } from '../history-utils/types.ts';
import { Button } from '@repo/ui/components';
import { useState } from 'react';
import { ChangeLine } from './history-change-line.tsx';
import { HISTORY_VISIBLE_GROUP_CHANGES } from './history-constants.ts';
import { HistoryRow } from './history-row.tsx';
export const GroupedChangeRow = t0 => {
  const $ = _c(13);
  const {
    group
  } = t0;
  const [expanded, setExpanded] = useState(false);
  const remaining = group.entries.length - HISTORY_VISIBLE_GROUP_CHANGES;
  let t1;
  if ($[0] !== expanded || $[1] !== group.entries) {
    t1 = expanded ? group.entries : group.entries.slice(0, HISTORY_VISIBLE_GROUP_CHANGES);
    $[0] = expanded;
    $[1] = group.entries;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const visibleEntries = t1;
  const fieldCount = group.entries.filter(_temp).length;
  let title = `${group.entries.length} changes`;
  if (fieldCount === group.entries.length) {
    title = `${group.entries.length} fields updated`;
  }
  if (fieldCount === 0) {
    title = `${group.entries.length} events`;
  }
  const t2 = group.entries[0];
  const t3 = title;
  let t4;
  if ($[3] !== visibleEntries) {
    t4 = visibleEntries.map(_temp2);
    $[3] = visibleEntries;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== expanded || $[6] !== remaining) {
    t5 = remaining > 0 ? <Button aria-expanded={expanded} className="w-full justify-start px-0 text-sm font-normal text-muted-foreground hover:text-muted-foreground @4xl/history:col-span-1" onClick={() => setExpanded(_temp3)} size={1} variant="ghost-transparent">{expanded ? "Show less" : `Show ${remaining} more changes`}</Button> : null;
    $[5] = expanded;
    $[6] = remaining;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== group.entries[0] || $[9] !== t4 || $[10] !== t5 || $[11] !== title) {
    t6 = <HistoryRow className="@4xl/history:items-start" entry={t2} title={t3} data-sentry-element="HistoryRow" data-sentry-component="GroupedChangeRow" data-sentry-source-file="history-grouped-change-row.tsx">{t4}{t5}</HistoryRow>;
    $[8] = group.entries[0];
    $[9] = t4;
    $[10] = t5;
    $[11] = title;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
function _temp(entry) {
  return entry.field !== null;
}
function _temp2(entry_0) {
  return <ChangeLine entry={entry_0} key={entry_0.id} />;
}
function _temp3(current) {
  return !current;
}